import { render } from "./setMeal.vue?vue&type=template&id=25d4c016&scoped=true"
import script from "./setMeal.vue?vue&type=script&lang=js"
export * from "./setMeal.vue?vue&type=script&lang=js"

import "./setMeal.vue?vue&type=style&index=0&id=25d4c016&lang=scss&scoped=true"

import exportComponent from "/root/workspace/zyy-iot_zyy-iot-web-v2_Ejzw/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d4c016"]])

export default __exports__